export enum CollapsibleState {
  None = "none",
  Collapsed = "collapsed",
  Expanded = "expanded",
  Full = "full",
}
